<template>
  <base-modal hide-footer hide-header @close="close">
    <div class="col-12" @click.stop="">
      <h3 class="editor-header">
        {{ item.type }}
      </h3>
      <marker-editor-map
        v-if="item"
        :id="item.id"
        class="item-map"
        :lat="parseFloat(item.lat)"
        :lon="parseFloat(item.lon)"
        :type="CULVERT"
        :draggable="false"
      />

      <div class="px-2">
        <div class="row">
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('common.id') }}</span>
            <span class="item-detail-text">{{ item.id }}</span>
          </div>
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('culvert.digiroad_id') }}</span>
            <span class="item-detail-text">{{ item.digiroad_id }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.type') }}</span>
            <span class="item-detail-text">{{ item.type }}</span>
          </div>
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('culvert.material') }}</span>
            <span class="item-detail-text">{{ item.material }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('culvert.size') }}</span>
            <span class="item-detail-text">{{ item.size }}</span>
          </div>
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.length') }}</span>
            <span class="item-detail-text">{{ item.length }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.city') }}</span>
            <span class="item-detail-text">{{ item.city }}</span>
          </div>
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.start_distance') }}</span>
            <span class="item-detail-text">{{ item.start_distance }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.road_num') }}</span>
            <span class="item-detail-text">{{ item.road_num }}</span>
          </div>
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.sec_num') }}</span>
            <span class="item-detail-text">{{ item.sec_num }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('culvert.owner') }}</span>
            <span class="item-detail-text">{{ item.owner }}</span>
          </div>
          <div class="col-6 nopads">
            <span class="item-detail-title">{{ $t('bridge.job') }}</span>
            <span class="item-detail-text">{{ item.job_area }}</span>
          </div>
        </div>
      </div>

      <div class="button-container col-sm-12">
        <button
          class="form-button btn btn-success"
          @click.stop="changeView"
        >
          {{ $t('menu.new_inspection') }}
        </button>
        <button
          class="form-button btn btn-primary"
          @click.stop="close"
        >
          {{ $t('common.close') }}
        </button>
      </div>
    </div>
  </base-modal>
</template>

<script>
import MarkerEditorMap from '../map/MarkerEditorMap'
import {mapHelper} from "@/components/mixins/MapMixin";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'CulvertDetails',
    components: {BaseModal, MarkerEditorMap},
    mixins: [mapHelper],
    props: {
        item: {
            type: Object,
            default: null
        },
        setInspectionParams: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            map: null,
            mapHelper
        }
    },
    methods: {
        close: function () {
            this.$emit('close')
        },
        changeView: function () {
            if (this.setInspectionParams) {
                this.setInspectionParams('inspectionWizard', 'culvert', this.item);
            }
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
.map-container {
    height: 30em;
    position: relative;
}

</style>
